import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {GroupPermValueItem} from '../../components/permission-groups/AddEditPermissionGroup';
import {ECADataType, Permission} from '../../types/permission-group/permission';

type PermissionInitialState = Pick<Permission, 'description'> & {
  groupName: string;
  switchLabels: GroupPermValueItem;
  isEditInProgress?: boolean;
  ecaData: ECADataType | null;
  budgetPermissionKeys: string[];
  evidenceUploadPermissionKeys: string[];
};

const initialState: PermissionInitialState = {
  groupName: '',
  description: '',
  switchLabels: {},
  isEditInProgress: false,
  ecaData: null,
  budgetPermissionKeys: [],
  evidenceUploadPermissionKeys: [],
};

const permissionSlice = createSlice({
  name: 'permission',
  initialState,
  reducers: {
    setPermission<K extends keyof PermissionInitialState>(
      state: PermissionInitialState,
      action: PayloadAction<{
        property: K;
        value: PermissionInitialState[K];
      }>
    ) {
      const {property, value} = action.payload;
      state[property] = value;
    },
    resetPermission: () => initialState,
  },
  selectors: {
    getPermission(state) {
      return state && state;
    },
  },
});

export const {setPermission, resetPermission} = permissionSlice.actions;
export const {getPermission} = permissionSlice.selectors;

export default permissionSlice.reducer;
